import React from "react";

export const SMART_TOURNAMENT_TYPE = "Smart Tournament";

export function SmartTournamentRules() {
  return (
    <>
      <li>Register for the tournament before registrations close.</li>
      <li>
        Each participant will play 4 scheduled matches, with one match played on different days.
      </li>
      <li>
        Once the tournament begins, you&apos;ll be automatically matched with an opponent for each
        scheduled match.
      </li>
      <li>Join your scheduled Ludo match within 10 minutes of the scheduled start time.</li>
      <li>
        Be the first player to get all 4 of your tokens to the center to win the match.
      </li>
      <li>
        Points will be awarded based on the match result:
        <ul className="ludo-rules-sublist">
          <li>🏆 Win = 1 Point</li>
          <li>🤝 Draw = 0.5 Point</li>
          <li>❌ Loss = 0 Points</li>
        </ul>
      </li>
      <li>
        If a player fails to join within the 10 minute grace period, they will be disqualified from
        the tournament, and their opponent will be awarded the win for that match.
      </li>
      <li>Once a match has been scheduled, it cannot be rescheduled.</li>
      <li>
        In case of a tie in the tournament standings, tie break rules will be applied automatically.
      </li>
      <li>
        After all participants complete their 4 matches, the Top 4 players, based on total points,
        will qualify for the Semi Finals.
      </li>
      <li>The winners of the Semi Finals will advance to the Final.</li>
      <li>🏆 Win the Final to become the Tournament Champion!</li>
      <li>
        <strong>Important:</strong>
        <ul className="ludo-rules-sublist">
          <li>The system&apos;s decision will be final in all cases.</li>
          <li>
            For the best experience, please play using Google Chrome on a stable internet
            connection.
          </li>
        </ul>
      </li>
    </>
  );
}

export function KnockoutTournamentRules() {
  return (
    <>
      <li>Register for the tournament before registrations close.</li>
      <li>Once the tournament begins, you&apos;ll be automatically matched with an opponent.</li>
      <li>Join your scheduled Ludo match within 10 minutes of the scheduled start time.</li>
      <li>
        Roll the dice, move your tokens, and be the first player to get all 4 tokens to the center
        to win the match.
      </li>
      <li>
        If a player fails to join within the 10 minute grace period, they will forfeit the match,
        and their opponent will automatically advance to the next round.
      </li>
      <li>Once a match has been scheduled, it cannot be rescheduled.</li>
      <li>Continue winning each round to progress through the tournament bracket.</li>
      <li>🏆 Win the Final to become the Tournament Champion!</li>
      <li>
        <strong>Important:</strong>
        <ul className="ludo-rules-sublist">
          <li>The system&apos;s decision will be final in all cases.</li>
          <li>
            For the best experience, please play using Google Chrome on a stable internet
            connection.
          </li>
        </ul>
      </li>
    </>
  );
}
